import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { loadStoreGoodsSearch, storeGoodsSearchCount } from '../api/store';
import ProductCardHorizontal from '../components/store/store_product_list/ProductCardHorizontal';
import ProductGridHorizontal from '../components/store/store_product_list/ProductGridHorizontal';
import ProductList from '../components/store/store_product_list/ProductList';
import Header from '../components/util/Header';
import GlobalSearchModal from '../modal/GlobalSearchModal';
import './SearchResult.css';

const buttonStyleOff = {
    border: '1px solid #666',
    borderRadius: '2em',
    padding: '4px 12px',
    marginRight: '8px',
    backgroundColor: '#fff',
    color: '#666',
    fontSize: '14px',
    fontWeight: '500',
    cursor: 'pointer'
}

const buttonStyleOn = {
    border: '1px solid #000',
    borderRadius: '2em',
    padding: '4px 12px',
    marginRight: '8px',
    backgroundColor: '#000',
    color: '#fff',
    fontSize: '14px',
    fontWeight: '700',
    cursor: 'pointer'
}

const GlobalSearchResult = () => {
    const [searchParams] = useSearchParams();
    const [resultCount, setResultCount] = useState(-1);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const keyword = searchParams.get('keyword');
    console.log(keyword);

    console.log('검색결과페이지 렌더랑')

    //검색 키워드가 바뀔때마다 페이지 초기화
    useEffect(()=>{

        setResultCount(-1);
    
        storeGoodsSearchCount(keyword).then(({count, error})=>{
            if(!error){
                setResultCount(count);
            }
        })
    }, [keyword])

    return (
        <div className="container">
            <Header useLogo={false} left={'home'} title={'통합검색 결과'} modalOpen={()=>setIsModalOpen(true)}/>
            <div className="result-list">
                <h1 className="result-title">{keyword} 검색 결과</h1>
                {resultCount > 0 && 
                    <div className="total-count">
                        <span>총</span> 
                        <strong>{resultCount}</strong> 
                        <span>건</span>
                    </div>
                }
                <div className="search-result-type-select">
                    <button style={buttonStyleOn}>#스토어</button>
                    <button style={buttonStyleOff}>#포인트샵</button>
                    <button style={buttonStyleOff}>#커뮤니티</button>
                    <button style={buttonStyleOff}>#이벤트</button>
                </div>
                {resultCount > 0 && 
                    <ProductList
                            fetchData={(start, end)=>loadStoreGoodsSearch(keyword, start, end)}
                            totalData={resultCount}
                            dataPerFetch={8}
                            ItemComponent={ProductCardHorizontal}
                            GridComponent={ProductGridHorizontal}
                        
                    />
                }
                {
                    resultCount === 0 && <div className="no-search">검색 결과가 없습니다.</div>
                }
            </div>

            {isModalOpen && (
            <>
            <div className="modal-wrapper">
                <GlobalSearchModal onClose={()=>setIsModalOpen(false)}/>
            </div>
            </>
        )}
        
        </div>
        );
};

export default GlobalSearchResult;